import { Link } from 'react-router-dom'
import OptimizedImage from './OptimizedImage'

const ProductCard = ({ product }) => {
  const mainImage = product.images?.find((img) => img.is_main) || product.images?.[0]

  // Получаем SKU из продукта или генерируем из названия
  const getSku = () => {
    if (product.sku) return product.sku
    // Генерируем SKU из первых букв названия
    const words = product.name.split(' ')
    const prefix = words.slice(0, 2).map(w => w[0]).join('').toUpperCase()
    const num = String(product.id).padStart(2, '0')
    return `${prefix}-${num}`
  }

  return (
    <Link to={`/products/${product.id}`} className="product-card">
      <div className="product-image-wrapper">
        <OptimizedImage
          src={mainImage?.image}
          alt={product.name}
          className="product-image"
          sizes="(max-width: 480px) 50vw, (max-width: 768px) 33vw, (max-width: 1024px) 25vw, 16vw"
          objectFit="contain"
          priority={true}
          placeholder={false}
        />
      </div>
      <div className="product-info">
        <div className="product-sku">{getSku()}</div>
      </div>
    </Link>
  )
}

export default ProductCard
